import React from 'react';
import { observer } from 'mobx-react';
import DraftItemListService from '../services/DraftItemListService';
import DraftItemList from './DraftItemList';
import { toJS } from 'mobx';
import DraftItemExtraColumnService from '../services/DraftItemExtraColumnService';

class DraftItemListContainer extends React.Component {
  static propTypes = {
    type: DraftItemList.propTypes.type,
  };

  render() {
    return (
      <DraftItemList
        fetching={DraftItemListService.fetch.fetching || DraftItemListService.submit.fetching}
        items={toJS(DraftItemListService.items)}
        pagination={toJS(DraftItemListService.page)}
        extraColumns={toJS(DraftItemExtraColumnService.columns)}
        onChange={DraftItemListService.handleTableChange}
        selectedItems={toJS(DraftItemListService.selectedItems)}
        onSelectItem={DraftItemListService.handleSelect}
        onChangeAssetStatus={DraftItemListService.handleChangeAssetStatus}
        onDelete={DraftItemListService.handleRemove}
        onPublish={DraftItemListService.handlePublish}
        type={this.props.type}
      />
    );
  }
}

export default observer(DraftItemListContainer);
